import { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { ContentfulImage, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsIngredientImage = (props: Props) => {
  const { baseUrl, alt } = props;

  return (
    <ContentfulImage baseUrl={baseUrl} options={IMAGE_OPTIONS} style={styles.image} alt={alt} />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_SIZE = 133;

const IMAGE_OPTIONS: ContentfulImageOptions = {
  w: IMAGE_SIZE,
  h: IMAGE_SIZE,
  fit: 'fill',
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  image: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    borderWidth: 1,
    borderColor: theme.colors.KALE,
    borderRadius: IMAGE_SIZE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  baseUrl: string;
  alt: string;
};

type ContentfulImageOptions = ComponentProps<typeof ContentfulImage>['options'];
